import { render } from "./PhoneRingOutline.vue?vue&type=template&id=2fce68d4"
import script from "./PhoneRingOutline.vue?vue&type=script&lang=js"
export * from "./PhoneRingOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__